import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ConnectedProps, connect } from "react-redux";
import Common from "us.common";
import { ConfigurationProvider } from "us.common/ConfigurationContext";
import { SignalRProvider } from "us.common/SignalRProvider";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import { asyncRoutes as iORoutes } from "us.collection.input-output/routes";
import collectionRoutes from "us.collection/routes";
import { RootState } from "us.helper/types";
import { FeatureFlagProvider } from "us.common/FeatureFlagContext";
import { DrawerProvider } from "us.common/context";
import { useAuth } from "us.helper/hooks/useAuth";
import { Loader, LoginRedirect } from "us.common/components";
import { History } from "history";

const { Page404, AppLayout, ConfigProvider } = Common.Components;

const App: React.FC<PropsFromRedux> = ({ currentLanguage }) => {
  const { isAuthenticated, isInitialized } = useAuth();

  if (!isInitialized) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    return (
      <UnauthenticatedTemplate>
        <BrowserRouter
          future={{
            v7_relativeSplatPath: true,
          }}
        >
          <LoginRedirect />
        </BrowserRouter>
      </UnauthenticatedTemplate>
    );
  }

  return (
    <AuthenticatedTemplate>
      <BrowserRouter
        future={{
          v7_relativeSplatPath: true,
        }}
      >
        <ConfigurationProvider>
          <FeatureFlagProvider>
            <SignalRProvider>
              <DrawerProvider>
                <AppLayout>
                  <ConfigProvider locale={currentLanguage as any}>
                    <Routes>
                      {collectionRoutes(5)}
                      {iORoutes}
                      <Route path="*" element={<Page404 />} />
                    </Routes>
                  </ConfigProvider>
                </AppLayout>
              </DrawerProvider>
            </SignalRProvider>
          </FeatureFlagProvider>
        </ConfigurationProvider>
      </BrowserRouter>
    </AuthenticatedTemplate>
  );
};

const mapStateToProps = (state: RootState) => ({
  currentLanguage: state.common.currentLanguage,
});

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(App);
